import { render } from "./BgTable.vue?vue&type=template&id=895a6aac&scoped=true"
import script from "./BgTable.vue?vue&type=script&lang=js"
export * from "./BgTable.vue?vue&type=script&lang=js"

import "./BgTable.vue?vue&type=style&index=0&id=895a6aac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895a6aac"]])

export default __exports__